import { Component, Input, OnInit } from '@angular/core';
import { IncidenciaTree } from '../../../interfaces/incidencia';
import { IncidenciaService } from '../../../providers/incidencia.service';

@Component({
  selector: 'app-ver-incidencia',
  templateUrl: './ver-incidencia.component.html',
  styleUrls: ['./ver-incidencia.component.scss']
})
export class VerIncidenciaComponent implements OnInit {

  @Input('idPropuesta') idPropuesta: any;

  public incidencias: IncidenciaTree[] = [];
  public cargando: boolean = false;
  public ver_automaticos: boolean = false;

  constructor(
    private incidenciaService: IncidenciaService
  ) { }

  ngOnInit() {
    this.incidencias = [];
    this.traerIncidencias();
  }

  traerIncidencias() {
    this.incidencias = [];

    let filtros = {
      idPropuesta: this.idPropuesta
    }

    if (this.ver_automaticos) {
      Object.assign(filtros, {
        ver_automaticos: true
      });
    }

    this.incidenciaService.getIncidencias(
      null,
      null,
      filtros
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1) {
          let incidencias_arr = respuesta.data.incidencias;
          incidencias_arr.forEach(element => {
            this.incidencias.push(new IncidenciaTree(
              element.idIncidencia,
              element.tipo.desc,
              element.fechaAlta,
              element.created_by,
              element.observacion
            ))
          });
          // console.log(this.incidencias);

        }
      },
      (err) => {

      },
      () => {

      }
    );
  }

}
